import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './components/Footer';

const LandingPage = lazy(() => import('./components/LandingPage'));
const AuthPage = lazy(() => import('./components/AuthPage'));
const SDKActivationPage = lazy(() => import('./components/SDKActivationPage'));
const TestImports = lazy(() => import('./components/TestImports'));
const DocsLayout = lazy(() => import('./components/docs/DocsLayout'));
const Introduction = lazy(() => import('./components/docs/Introduction'));
const QuickStart = lazy(() => import('./components/docs/QuickStart'));
const Installation = lazy(() => import('./components/docs/Installation'));
const AttributeSystemDocs = lazy(() => import('./components/docs/AttributeSystemDocs'));
const WebhookGuide = lazy(() => import('./components/docs/WebhookGuide'));
const DeviceManagerDocs = lazy(() => import('./components/docs/DeviceManagerDocs'));
const MiddlewareDocs = lazy(() => import('./components/docs/Middleware'));
const AuthFlowOverview = lazy(() => import('./components/docs/AuthFlowOverview'));
const PhoneAuthGuide = lazy(() => import('./components/docs/PhoneAuthGuide'));
const EmailAuthGuide = lazy(() => import('./components/docs/EmailAuthGuide'));
const MagicLinkGuide = lazy(() => import('./components/docs/MagicLinkGuide'));
const OAuthGuide = lazy(() => import('./components/docs/OAuthGuide'));
const ConfigurationReference = lazy(() => import('./components/docs/ConfigurationReference'));
const EnvReference = lazy(() => import('./components/docs/EnvReference'));
const AttributeModalDocs = lazy(() => import('./components/docs/AttributeModalDocs'));
const MultiAppGuide = lazy(() => import('./components/docs/MultiAppGuide'));
const AgentReference = lazy(() => import('./components/docs/AgentReference'));
const HostedLoginPage = lazy(() => import('./components/HostedLoginPage'));
const BrandingGuide = lazy(() => import('./components/docs/BrandingGuide'));
const NotFound = lazy(() => import('./components/NotFound'));

const App = () => {
    return (
        <BrowserRouter>
            <div className="flex min-h-screen flex-col">
                <Suspense fallback={<div>Loading...</div>}>
                    <div className="flex-1">
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/test-imports" element={<TestImports />} />
                            {/* Test route for AuthPage */}
                            <Route path="/test-auth" element={
                                <AuthPage
                                    sdkDevKey="test-key-123"
                                    theme={{
                                        primaryColor: '#4F46E5',
                                        logoUrl: '/images/logo.png'
                                    }}
                                />
                            } />
                            <Route path="/auth" element={<AuthPage sdkDevKey={process.env.SSIMPLE_SDK_DEV_KEY || ''} />} />
                            <Route path="/auth/login" element={<HostedLoginPage />} />
                            <Route path="/dev-sdk/:activationToken/activate" element={<SDKActivationPage />} />

                            <Route path="/docs" element={<DocsLayout />}>
                                <Route index element={<Introduction />} />
                                <Route path="quickstart" element={<QuickStart />} />
                                <Route path="installation" element={<Installation />} />
                                <Route path="env-reference" element={<EnvReference />} />
                                <Route path="configuration" element={<ConfigurationReference />} />
                                <Route path="auth-flow" element={<AuthFlowOverview />} />
                                <Route path="phone-auth" element={<PhoneAuthGuide />} />
                                <Route path="email-auth" element={<EmailAuthGuide />} />
                                <Route path="magic-link" element={<MagicLinkGuide />} />
                                <Route path="oauth" element={<OAuthGuide />} />
                                <Route path="attributes" element={<AttributeSystemDocs />} />
                                <Route path="components/attribute-modal" element={<AttributeModalDocs />} />
                                <Route path="middleware" element={<MiddlewareDocs />} />
                                <Route path="webhooks" element={<WebhookGuide />} />
                                <Route path="device-management" element={<DeviceManagerDocs />} />
                                <Route path="multi-app" element={<MultiAppGuide />} />
                                <Route path="agents" element={<AgentReference />} />
                                <Route path="branding" element={<BrandingGuide />} />
                            </Route>
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </div>
                    <Footer />
                </Suspense>
            </div>
        </BrowserRouter>
    );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<App />);
